/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import {KatButton} from '@amzn/katal-react';
import type {RefObject} from 'react';
import * as styles from '../styles/Button.module.scss';

type ButtonProps = KatButton.Props & {
  ref?: RefObject<KatButton.Element>;
};
export const Button = ({ref, icon, label, ...rest}: ButtonProps) => {
  return (
    <KatButton ref={ref} {...rest}>
      <div className={styles.contentContainer}>
        {icon && <span className={styles.icon}>{icon}</span>}
        {label}
      </div>
    </KatButton>
  );
};
